import { observable, computed, action } from "mobx";
import {
  RStatus,
  UserInfo,
  MachineItem,
  SubAccount,
  CurrentSub,
  FundBalance,
  UserBalance,
  MinerGroup,
  CurrencyCoinFee,
  ExchangeRate,
  EarnData,
  AccountSummary,
  CommonState,
  ZeroRate,
  FundSummary,
  powerChart,
  minerChart,
  earnChart,
  CurrentSetting,
} from "@/models/";
import { rootStore } from "@/index";

import API from "@/apis";
import config from "@/config.json";
import moment from "moment";
const { pool_uuid } = config;
import { CoinHelper, RepayCoinType } from "@/utils";

import { CommonBuilder } from "@/models";
import { getDeviceId } from "@/utils/fingerprint";
import { message } from "antd";

export class SessionStore {
  @observable public selectMenu: string;
  @observable public error?: Error;
  @observable public loading: boolean = false;
  @observable public signed: boolean = false;
  @observable public sessionStatus: RStatus = RStatus.Init;
  @observable public userBalance: UserBalance;
  @observable public userinfo: UserInfo;
  @observable public fundBalance: FundBalance;
  @observable public link: string;
  @observable public observerLink: string;

  @observable public subAccountList: CommonState<SubAccount[]>;

  @observable public currentSubAcount: CurrentSub;
  // 暂时单独丢出一个字段是怕影响太多使用的地方
  @observable public currentSubAccountStatus: RStatus;

  @observable public sortSubList: CurrentSub[];

  @observable public groupList: MinerGroup[];

  @observable public feeList: CurrencyCoinFee[];
  @observable public queryNum: String;

  @observable public rateList: ExchangeRate;

  @observable public coinEarnData: EarnData;

  @observable public isWatcherTheme: boolean;

  @observable public summary: AccountSummary;
  @observable public subSummary: AccountSummary;

  @observable public currentSubAccountTabKey: string;

  @observable public currentLoginType: string;

  @observable public googleCode: string;
  @observable public googleVisible: boolean;

  @observable public zeroRate: ZeroRate;
  @observable public inZeroActive: boolean;
  @observable public lastZeroActive: boolean;
  @observable public currentSummaryStatus: RStatus;
  @observable public fundSummaryStatus: RStatus;
  @observable public fundSummary: FundSummary;
  @observable public powerChartData: powerChart;
  @observable public minerChartData: minerChart;
  @observable public earnChartData: earnChart;
  @observable public deviceId: string;
  @observable public settingList: CurrentSetting;
}

export class Session extends SessionStore {
  constructor() {
    super();
    this.sessionStatus = RStatus.Init;
    this.signed = false;

    this.userinfo = {} as UserInfo;

    this.userBalance = {} as UserBalance;

    this.fundBalance = {
      BTC: {
        lockBsvMoney: 0,
        poolTotalInvest: 0,
        userInvestMoney: 0,
        userInvestEarn: 0,
        currentRate: 0,
      },
      BSV: {
        lockBsvMoney: 0,
        poolTotalInvest: 0,
        userInvestMoney: 0,
        userInvestEarn: 0,
        currentRate: 0,
      },
    } as FundBalance;

    // this.subAccountList = {
    //   data_list: [],
    //   total_num: 0,
    //   total_page: 0,
    //   loading: false
    // };
    this.subAccountList = CommonBuilder.init([]);

    // const localCurretSub: any = localStorage.getItem("currentSub");
    const localCurrentSubAcount: any = localStorage.getItem("currentSubAcount");

    // this.currentSub = localCurretSub ? JSON.parse(localCurretSub) : ({} as SubAccount);
    this.currentSubAcount = localCurrentSubAcount
      ? JSON.parse(localCurrentSubAcount)
      : ({} as CurrentSub);
    this.currentSubAccountStatus = RStatus.Init;

    this.sortSubList = [];

    this.selectMenu = "dashboard";

    this.groupList = [];

    this.feeList = [];

    this.rateList = {} as ExchangeRate;

    this.coinEarnData = {} as EarnData;

    this.summary = {} as AccountSummary;
    this.subSummary = {} as AccountSummary;

    // 观察者主题检测
    this.isWatcherTheme = false;

    this.currentSubAccountTabKey = "1";
    // 登陆 or 注册
    this.currentLoginType = "login";

    this.googleCode = "";
    this.googleVisible = false;
    this.getUserInfo();

    this.observerLink = "";
    this.deviceId = "";
    this.initDeviceId();

    this.settingList = {} as CurrentSetting;
  }

  @action
  initDeviceId = async () => {
    this.deviceId = await getDeviceId();
    // console.log(this.deviceId);
  };

  // 获取用户信息 ,可以拿来检查token有效期
  @action
  getUserInfo = async () => {
    //观察者不登录
    if (location.pathname.match(/sub\/\w+/gim)) {
      return;
    }
    // 登录注册忘记密码
    if (
      location.pathname.match(/login/gim) ||
      location.pathname.match(/register/gim) ||
      location.pathname.match(/forget/gim)
    ) {
      return;
    }
    //隐私政策，用户协议
    if (
      location.pathname.match(/privacyPolicy/gim) ||
      location.pathname.match(/userAgreement/gim)
    ) {
      return;
    }

    if (location.pathname.match(/about/gim) || location.pathname.match(/service/gim)) {
      return;
    }

    const shouldRedirect = location.search.includes("redirect");
    if (!localStorage.token && !shouldRedirect) {
      location.href = "/home?redirect=no";
      return;
    }

    if (localStorage.token) {
      try {
        const { data } = await API.User.findUser();
        this.userinfo = data.data;
        this.signed = true;
      } catch (error) {}
    }
  };

  // 发送验证码
  @action
  getVerifyCode = async (data) => {
    try {
      await API.User.sendCode(data);
      message.info("已发送验证码,注意查收");
      return true;
    } catch (error) {
      return false;
    }
  };

  // 地址验证码
  @action
  setWithdrawAddrSms = async (data) => {
    try {
      await API.User.setWithdrawAddrSms(data);
      message.info("已发送验证码,注意查收");
      return true;
    } catch (error) {
      return false;
    }
  };

  //退出
  @action
  userLogout = () => {
    this.signed = false;
  };

  // 收益预估
  @action
  coinEarn = async () => {
    try {
      const { data } = await API.User.coinEarn();
      this.coinEarnData = data.data;
    } catch (error) {}
  };

  // 获取子账号列表
  // TODO
  @action
  getSubAccountList = async (sort?, sortType?, showHidden?) => {
    this.subAccountList = CommonBuilder.process(
      this.subAccountList.data,
      this.subAccountList.total
    );
    try {
      const { data } = await API.User.subUserListIndex({
        page: 1,
        page_size: 100,
        sort_type: sort,
        sort_field: sortType,
        show_hidden: showHidden,
      });
      const arr = data.data.data_list;

      this.subAccountList = CommonBuilder.success(arr, arr.length);
    } catch (error) {
      this.subAccountList = CommonBuilder.failed(new Error(error));
      // this.subAccountList.loading = false;
    }
  };

  // 获取单个子账户详情
  @action
  getSubAccountInfo = async (id) => {
    this.currentSubAccountStatus = RStatus.Pending;
    try {
      // todo
      const { data } = await API.User.getSubUserInfo({
        id: id || this.currentSubAcount.key,
      });
      // this.currentSubAcount = data.data;
      this.currentSubAcount = data.data;
      this.currentSubAccountStatus = RStatus.Fulfilled;
      localStorage.setItem("currentSubAcount", JSON.stringify(data.data));
      this.getSortSubAccountList();
      // this.getDefaultSubAccount();
      this.getSetting(id);
      // this.getSubSummary(id);
    } catch (error) {
      this.currentSubAccountStatus = RStatus.Rejected;
    }
  };

  @action
  getDefaultSubAccount = async (id?) => {
    this.currentSubAccountStatus = RStatus.Pending;
    try {
      const { data } = await API.User.getSubUserInfo({
        id: id || this.currentSubAcount.key,
      });
      // this.currentSubAcount = data.data;
      this.currentSubAcount = data.data;
      localStorage.setItem("currentSubAcount", JSON.stringify(data.data));
      this.currentSubAccountStatus = RStatus.Fulfilled;
      this.getSubSummary(id || this.currentSubAcount.key);
      this.getSetting(id || this.currentSubAcount.key);
    } catch (error) {
      this.currentSubAccountStatus = RStatus.Rejected;
    }
  };

  // 获取面板信息汇总
  @action
  getSummary = async () => {
    this.currentSummaryStatus = RStatus.Pending;
    try {
      const { data } = await API.User.summary({});
      let summaryList = data.data;
      let summary: any = {};
      summary.hashRate = summaryList.hash_rate;
      summary.hashRateDay = summaryList.hash_rate_day;
      summary.onlineWorker = summaryList.online_worker;
      summary.lowWorker = summaryList.low_worker;
      summary.offlineWorker = summaryList.offline_worker;
      summary.btcProfitDay = summaryList.btc_profit_day;
      summary.bsvProfitDay = summaryList.bsv_profit_day;
      summary.btcProfitPredict = summaryList.btc_predict_profit;
      summary.bsvProfitPredict = summaryList.bsv_predict_profit;
      summary.ltcProfitDay = summaryList.ltc_profit_day;
      summary.ltcPredictProfit = summaryList.ltc_predict_profit;
      summary.dogeProfitDay = summaryList.doge_profit_day;
      summary.dogePredictProfit = summaryList.doge_predict_profit;
      summary.currency = summaryList.currency;
      this.summary = summary;
      this.currentSummaryStatus = RStatus.Fulfilled;
    } catch {
      this.currentSummaryStatus = RStatus.Rejected;
    }
  };

  // 获取资金管理汇总信息
  @action
  getFundSummary = async () => {
    this.fundSummaryStatus = RStatus.Pending;
    try {
      const { data } = await API.User.getFundSummary();
      this.fundSummary = data.data;
      this.fundSummaryStatus = RStatus.Fulfilled;
    } catch {
      this.fundSummaryStatus = RStatus.Rejected;
    }
  };

  // 获取子账户汇总信息
  @action
  getSubSummary = async (id, key?) => {
    try {
      const { data } = await API.User.getSubSummary({ puid: id, key });
      this.subSummary = data.data;
    } catch {}
  };

  @action
  getAllBalance = async (type) => {
    try {
      const { data } = await API.User.getAllBalance({
        type,
      });
      let balance = data.data;
      balance.lockBsvMoney = CoinHelper.amount2bsv(balance.lockBsvMoney);
      balance.userInvestMoney = CoinHelper.amount2bsv(balance.userInvestMoney);
      balance.userInvestEarn = CoinHelper.amount2bsv(balance.userInvestEarn);
      balance.poolTotalInvest = CoinHelper.amount2bsv(balance.poolTotalInvest);
      balance.lockBsvMoneyPplns = CoinHelper.amount2bsv(balance.lockBsvMoneyPplns);
      this.fundBalance[type] = data.data;
    } catch (error) {}
  };

  // 获取子账户排序列表
  @action
  getSortSubAccountList = async () => {
    try {
      const { data } = await API.User.subUserList({ id: this.currentSubAcount.key });
      this.sortSubList = data.data;
    } catch (error) {}
  };

  // 获取观察者链接
  @action
  getWatchKey = async () => {
    let currentSubAcountId = this.currentSubAcount.key;
    try {
      const { data } = await API.User.getObserverKey({ subuser_id: currentSubAcountId });
      let authKey = data.data;
      this.observerLink = `${window.origin}/sub/${authKey}`;
    } catch (error) {}
  };

  //获取用户资金数据
  @action
  getBalance = async (id?, key?) => {
    const upData = id ? { puid: id } : {};
    if (key) {
      upData["key"] = key;
    }
    try {
      const { data } = await API.User.getBalance(upData);
      // console.log(data.data);
      this.userBalance = data.data;
    } catch (error) {}
  };

  // 获取矿工分组
  @action
  getGroup = async (id?, key?) => {
    let upData = { puid: id ? id : "", key: key ? key : "" };
    try {
      const { data } = await API.User.workerGroup(upData);
      this.groupList = data.data;
    } catch (error) {}
  };

  // 获取汇率
  @action
  getCurrencyRate = async () => {
    try {
      const { data } = await API.User.getRate();
      this.rateList = data.data;
    } catch (error) {}
  };

  // 获取手续费
  @action
  getCurrentFee = async (coin) => {
    let query_num = moment().unix().toString() + Math.floor(Math.random() * 999999).toString();
    try {
      const { data } = await API.User.getFee({
        query_num: query_num,
        coin_type: coin,
      });

      let feeList = [] as any;
      let feedata = data.data;
      let lowFeeSize = CoinHelper.amount2bsv(feedata[0].feeSize);
      let lowFeeTx = CoinHelper.amount2bsv(feedata[0].feeTx);
      let highFeeSize = feedata.length == 2 ? CoinHelper.amount2bsv(feedata[1].feeSize) : undefined;
      let highFeeTx = feedata.length == 2 ? CoinHelper.amount2bsv(feedata[1].feeTx) : undefined;
      // console.log("=========", feedata);

      feeList.push({
        size: lowFeeSize,
        tx: lowFeeTx,
        text: `${rootStore.locale.get("WithDraw.low")} ${lowFeeSize} ${RepayCoinType[coin]}/KB`,
        type: feedata[0].type,
      });
      if (feedata.length == 2) {
        feeList.push({
          size: highFeeSize,
          tx: highFeeTx,
          text: `${rootStore.locale.get("WithDraw.height")} ${highFeeSize} ${
            RepayCoinType[coin]
          }/KB`,
          type: feedata[1].type,
        });
      }

      this.feeList = feeList;
      this.queryNum = query_num;
    } catch {}
  };

  @action
  getPowerGraphic = async (type, start, end, isTotal?, puid?, key?) => {
    let json = {
      type: type,
      date_start: start,
      date_end: end,
    };
    if (isTotal) {
      json["is_total"] = isTotal;
    }
    if (puid) {
      json["puid"] = puid;
    }
    if (key) {
      json["key"] = key;
    }
    try {
      const { data } = await API.User.getHashGraphic(json);
      this.powerChartData = data.data;
    } catch {}
  };

  @action
  getMinerGraphic = async (type, start, end, isTotal?, puid?, key?) => {
    let json = {
      type: type,
      date_start: start,
      date_end: end,
    };
    if (isTotal) {
      json["is_total"] = isTotal;
    }
    if (puid) {
      json["puid"] = puid;
    }
    if (key) {
      json["key"] = key;
    }
    try {
      const { data } = await API.User.staWorkNum(json);
      this.minerChartData = data.data;
    } catch {}
  };

  @action
  getEarnGraphic = async (type, start, end, isTotal?, puid?, key?) => {
    let json = {
      type: type,
      date_start: start,
      date_end: end,
    };
    if (isTotal) {
      json["is_total"] = isTotal;
    }
    if (puid) {
      json["puid"] = puid;
    }
    if (key) {
      json["key"] = key;
    }
    try {
      const { data } = await API.User.getProfitGraphic(json);
      this.earnChartData = data.data;
    } catch {}
  };

  @computed
  get defaultGroup() {
    return this.groupList.length > 0 ? this.groupList[0] : ({} as MinerGroup);
  }

  @computed
  get lastSortChild() {
    return this.sortSubList[0] ? this.sortSubList[0] : ({} as CurrentSub);
  }

  @computed
  get defaultFee() {
    return this.feeList.length > 0 ? this.feeList[0].tx : undefined;
  }

  @computed
  get bsvHeigher() {
    return this.coinEarnData.bsv_earn > this.coinEarnData.btc_earn_tran ? true : false;
  }

  @action
  setWatchTheme = (flag: boolean) => {
    this.isWatcherTheme = flag;
  };

  @action
  setSelectMenu = (data: any) => {
    // console.log(data);
    if (data == "/" || data == "") {
      data = "dashboard";
    }
    if (this.selectMenu != data) {
      this.selectMenu = data;
    }
  };

  @action
  getOneAppVersion = async () => {
    try {
      const { data } = await API.User.getOneAppVersion();
      this.link = data.data[0].link;
    } catch (error) {}
  };

  @computed
  get isObservable() {
    // console.log("flag", this.userinfo.watcher_flag);
    return this.userinfo.watcher_flag;
  }

  @action
  setCurrentLoginType = (key: string = "login") => {
    this.currentLoginType = key;
  };

  @action
  setCurrentSubAccountTabKey = (tab: string = "1") => {
    this.currentSubAccountTabKey = tab;
  };

  @action
  setGoogleCode = (str: string) => {
    this.googleCode = str;
  };

  @action
  setGoogleVisible = (visible: boolean) => {
    this.googleVisible = visible;
  };

  // 获取设置列表
  @action
  getSetting = async (id?) => {
    try {
      const { data } = await API.User.getSetting({ id: id ? id : 0 });
      this.settingList = data.data;
    } catch (error) {}
  };

  // 0费率活动是否开启参数
  @action
  getZeroRate = async (puid?) => {
    const json = puid ? { puid } : {};
    try {
      const { data } = await API.Open.getZeroRate(json);
      this.zeroRate = data.data;
      let start = this.zeroRate.startTime;
      let end = this.zeroRate.endTime;
      this.inZeroActive = this.zeroRate.isZeroRate;
      if (start == "" || end == "") {
        this.lastZeroActive = false;
      } else {
        let now = moment().utc().format();
        let lastStart = moment(start).add(1, "d");
        let lastEnd = moment(end).add(1, "d");
        let lastBetween = moment(now).isBetween(lastStart, lastEnd, "day", "[]");
        this.lastZeroActive = lastBetween;
      }
      // console.log("=======", this.zeroRate, this.inZeroActive, this.lastZeroActive);
    } catch (error) {}
  };

  // 0费率活动时间
  @computed
  get inActive() {
    let activeStart = moment("2020/9/16 00:00:00").utc().format();
    let activeEnd = moment("2020/9/18 22:00:00").utc().format(); //
    let now = moment().utc().format();
    let timeBetween = moment(now).isBetween(activeStart, activeEnd, "seconds", "[]");
    let inActive = timeBetween;
    return inActive;
  }

  // 时区偏移
  @action
  offSetTimeUnix = (current: number) => {
    let userZone = this.userinfo.time_zone;
    let minus = userZone >= 0 ? "+" : "-";
    let abs = Math.abs(userZone);
    let utcTime = moment
      .utc(current * 1000)
      .format()
      .slice(0, -1);
    let timeZone = "";
    if (abs >= 10) {
      timeZone = `${userZone}:00`;
    } else {
      timeZone = `${minus}0${abs}:00`;
    }
    return `${utcTime}${timeZone}`;
  };
}

export default Session;
